export function fromStore (key) {
  return {
    get () {
      return this.$store.state.form[key]
    },
    set (value) {
      this.$store.commit('updateForm', { key, value })
    }
  }
}

export function validate (f, isUpload) {
  const hasGivenAuthor = f.anon === 'Yes' || f.anon === 'No'
  const isAuthor = f.anon === 'Yes'
  const authorValid = ((!isAuthor && hasGivenAuthor) || (isAuthor && f.terms))
  if (!isUpload) {
    return !(authorValid && f.submissiontype !== '' && f.link.length > 10)
  }
  return !(authorValid && f.email.length > 10)
}
